module.exports = __webpack_public_path__ + "static/img/stay-option-icon-workshop.ddcd22f4.svg";